import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VProgressCircular,{attrs:{"color":_vm.color,"size":_vm.size,"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }